package com.anjuros.website.templates.template1.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template1.components.Template1SectionTitle
import com.anjuros.website.templates.template1.modules.Template1GalleryCategory
import com.anjuros.website.templates.template1.modules.Template1GalleryItem
import com.anjuros.website.templates.template1.modules.Template1Section
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.modules.template1GalleryItems
import com.anjuros.website.templates.template1.styles.Template1GalleryItemShadowStyle
import com.anjuros.website.templates.template1.styles.Template1SectionPaddingStyle
import com.anjuros.website.templates.template1.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun Template1Services( width:Int = 70) {
    Box(
        modifier = Template1SectionPaddingStyle.toModifier()
            .id(Template1Section.Service.id)
            .fillMaxSize()
            .backgroundColor(
                rgb(252, 248, 244)
            ),
        contentAlignment = Alignment.Center
    ) {
        Template1Gallery(width = width)
    }
}

@Composable
fun Template1Gallery(
    width: Int=70
) {

    var selectedCategory by remember {
        mutableStateOf(
            Template1GalleryCategory.SERVICE1
        )
    }

    var visible by remember {
        mutableStateOf(true)
    }

    val scope = rememberCoroutineScope()

    val products =
        template1GalleryItems.filter {
            it.category == selectedCategory
        }

    Column(
        modifier = Modifier
            .id("gallery")
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {

        Template1SectionTitle(
            badge = ResKey.TEMPLATE1_GALLERY_BADGE,
            title = ResKey.TEMPLATE1_GALLERY_TITLE,
            text = ResKey.TEMPLATE1_SERVICE_DESC
        )

        Spacer()

        Template1GalleryCategories(
            selected = selectedCategory,
            onSelected = {

                if (it != selectedCategory) {

                    visible = false

                    scope.launch {

                        delay(250.milliseconds)

                        selectedCategory = it

                        // Give the new items a moment to render
                        delay(30.milliseconds)

                        visible = true
                    }
                }
            }
        )

        Spacer()

        Template1GalleryGrid(
            items = products,
            visible = visible,
            width = width
        )
    }
}


@Composable
private fun Template1GalleryGrid(
    items: List<Template1GalleryItem>,
    visible: Boolean,
    width:Int = 70
) {

    SimpleGrid(
        modifier = Modifier
            .fillMaxWidth(width.percent)
            .minHeight(500.px),
        numColumns = numColumns(
            base = 1,
            md = 2,
            lg = 3
        )
    ) {

        items.forEachIndexed { index, item ->

            Box(modifier = Modifier.fillMaxSize().displayUntil(Breakpoint.LG),
                contentAlignment = Alignment.Center) {
                Template1GalleryImage(
                    item = item,
                    visible = visible,
                    index = index
                )
            }
            Template1GalleryImage(
                modifier =  Template1GalleryItemShadowStyle.toModifier()
                    .displayIfAtLeast(Breakpoint.LG),
                item = item,
                visible = visible,
                index = index
            )
        }
    }
}

@Composable
private fun Template1GalleryCategories(
    selected: Template1GalleryCategory,
    onSelected: (Template1GalleryCategory) -> Unit
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(leftRight = 24.px).gap(10.px)
            .margin(topBottom = 60.px).overflow(Overflow.Auto),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Template1GalleryCategory.entries.forEach { category ->
            Box(
                modifier = Modifier.borderRadius(
                    50.percent
                )
                    .backgroundColor(if (selected == category) Template1Theme.Primary.getColor() else Colors.White)
                    .border(
                        1.px,
                        LineStyle.Solid,
                        if (selected == category) Template1Theme.Primary.getColor() else rgb(
                            220,
                            210,
                            204
                        )
                    ).padding(leftRight = 22.px, topBottom = 11.px).cursor(Cursor.Pointer)
                    .transition(Transition.of(TransitionProperty.All, 220.ms))
                    .onClick { onSelected(category) }) {
                SpanText(
                    LocalText(category.text),
                    Modifier.fontSize(14.px).fontWeight(FontWeight.Medium)
                        .align(Alignment.Center)
                        .color(if (selected == category) Colors.White else Template1Theme.Primary.getColor())
                )
            }
        }
    }
}


@Composable
private fun Template1GalleryImage(
    modifier: Modifier = Template1GalleryItemShadowStyle.toModifier(),
    item: Template1GalleryItem,
    visible: Boolean,
    index: Int
) {

    Box(
        modifier = modifier
            .margin(10.px)
            .borderRadius(4.px)

            .opacity(
                if (visible) 1f else 0f
            )
            .transition(
                Transition.of(
                    "opacity",
                    450.ms,
                    delay = if (visible) {
                        (index * 70).ms
                    } else {
                        0.ms
                    }
                )
            )
    ) {

        AnjurosImage(
            modifier = Modifier
                .fillMaxSize()
                .objectFit(ObjectFit.Cover),
            src = item.image,
            alt = ""
        )
    }
}